import { useAnalytics } from './useAnalytics';
import { IErrorMessageParam, ILoadingTimeParam } from './useEventsParams';

export interface ILootboxParams {
  lootboxId: string;
  lootboxName?: string;
  lootboxAmount: number;
  transactionHash?: string;
}

enum LootboxEventName {
  GetMarketplace = 'get_LOOTBOX_STORE',
  GetOwned = 'get_lootbox_owned',
  Buy = 'buy_lootbox',
  PurchaseInProgress = 'lootbox_purchase_in_progress',
  PurchaseSuccess = 'lootbox_purchase_success',
  PurchaseError = 'lootbox_purchase_error',
  Open = 'open_lootbox',
  OpenSuccess = 'open_lootbox_success',
  OpenError = 'open_lootbox_error',
}

export const useLootboxEvents = () => {
  const { sendEvent } = useAnalytics();

  return {
    sendLootboxGetMarketplaceEvent: (params: ILoadingTimeParam) =>
      sendEvent(LootboxEventName.GetMarketplace, params, true),
    sendLootboxGetOwnedEvent: (params: ILootboxParams & ILoadingTimeParam) =>
      sendEvent(LootboxEventName.GetOwned, params, false),
    sendLootboxBuyEvent: (params: ILootboxParams) => sendEvent(LootboxEventName.Buy, params, true),
    sendLootboxPurchaseInProgressEvent: (params: ILootboxParams) =>
      sendEvent(LootboxEventName.PurchaseInProgress, params, false),
    sendLootboxPurchaseSuccessEvent: (params: ILootboxParams) =>
      sendEvent(LootboxEventName.PurchaseSuccess, params, false),
    sendLootboxPurchaseErrorEvent: (params: ILootboxParams & IErrorMessageParam) =>
      sendEvent(LootboxEventName.PurchaseError, params, false),
    sendLootboxOpenEvent: (params: ILootboxParams) => sendEvent(LootboxEventName.Open, params, true),
    sendLootboxOpenSuccessEvent: (params: ILootboxParams & { drawnRewards: string[] }) =>
      sendEvent(LootboxEventName.OpenSuccess, params, false),
    sendLootboxOpenErrorEvent: (params: ILootboxParams & IErrorMessageParam) =>
      sendEvent(LootboxEventName.OpenError, params, false),
  };
};
